import Vue from 'vue';

/**
 * Class AttributeService
 */
export default class AttributeService extends Vue {

    private customActions = {
        show: { method: 'GET', url: 'auth/attribute/platform{/id_platform}' },
        store: { method: 'POST', url: 'auth/attribute/platform{/id_platform}' },
        list: { method: 'GET', url: 'auth/attribute/platform' }
        
    };

    private resource: any = this.$resource(
        "auth/attribute/platform{/id_platform}",
        {},
        this.customActions
    );

    // GET 
    public show(id_platform: any) {
        return this.resource.show({ id_platform }).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    // GET 
    public list() {
        return this.resource.list().then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }

    public store(id_platform: any, data: any) {

        return this.resource.store({ id_platform }, data).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}
